module.exports = __webpack_public_path__ + "static/media/note1.3e4a4fd3.png";